import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './importers.intl.json';

export const useImportersIntl = () => useIntlModule(messages);

export type IntlImporters = ReturnType<typeof useImportersIntl>;
